<app-dt-card class="cronologia-perfil">
  <div class="cp-header">
    <h3 class="dt-titulo cp-title">
      <mat-icon>timeline</mat-icon>
      Cronología de aplicación del perfil
    </h3>
    <div class="cp-acciones">
      <button
        irxBotonIcono
        (click)="toggleAyuda()"
        tooltip="¿Qué significan los estados y los colores?"
        [activo]="mostrarAyuda()"
      >
        <mat-icon>help_outline</mat-icon>
      </button>
      <button
        irxBoton="secundario"
        (click)="abrirConfigReal()"
        tooltip="Ver configuración real del dispositivo y sus discrepancias con la deseada"
      >
        <mat-icon>difference</mat-icon>
        Config real vs. deseada
      </button>
    </div>
  </div>

  <!-- Panel de ayuda: glosario de estados + leyenda de colores -->
  @if (mostrarAyuda()) {
    <div class="cp-ayuda">
      <div class="cp-ayuda-col">
        <div class="cp-ayuda-tit">
          <mat-icon>send</mat-icon>
          Estado de la fila (transporte)
        </div>
        <p class="cp-ayuda-sub">
          ¿Se logró despachar el downlink al servidor LoRaWAN?
        </p>
        @for (it of estadosCola; track it.estado) {
          <div class="cp-ayuda-item">
            <span class="cp-dot" [class]="it.clase"></span>
            <b>{{ it.estado }}</b>
            <span>{{ it.desc }}</span>
          </div>
        }
      </div>

      <div class="cp-ayuda-col">
        <div class="cp-ayuda-tit">
          <mat-icon>router</mat-icon>
          Estado del dispositivo (comando)
        </div>
        <p class="cp-ayuda-sub">
          ¿El dispositivo recibió y ejecutó el comando?
        </p>
        @for (it of estadosDispositivo; track it.estado) {
          <div class="cp-ayuda-item">
            <span class="cp-dot" [class]="it.clase"></span>
            <b>{{ it.estado }}</b>
            <span>{{ it.desc }}</span>
          </div>
        }
      </div>

      <div class="cp-ayuda-col">
        <div class="cp-ayuda-tit">
          <mat-icon>category</mat-icon>
          Procesos
        </div>
        <p class="cp-ayuda-sub">Cada proceso tiene un color de referencia.</p>
        @for (p of procesos; track p.clase) {
          <div class="cp-ayuda-item">
            <span class="cp-proc-chip" [class]="p.clase"></span>
            <b>{{ p.label }}</b>
            <span>{{ p.desc }}</span>
          </div>
        }
      </div>
    </div>
  }

  <!-- Estado de la configuración deseada -->
  @if (configDeseada) {
    <div class="cp-estado">
      <span class="cp-label">Configuración deseada</span>
      <app-dt-estado
        [etiqueta]="estadoConfig || 'Pendiente'"
        [tono]="estadoConfigTono()"
      />
      @if (diffsCount > 0) {
        <span class="cp-meta">{{ diffsCount }} campo(s) en discrepancia</span>
      }
      @if (reintentos > 0) {
        <span class="cp-meta">· intento {{ reintentos }}</span>
      }
      @if (bloqueadoMin; as min) {
        <span class="cp-meta cp-bloqueo">· reintenta en ~{{ min }} min</span>
      }
      @if (configDeseada?.fechaActualizacion || configDeseada?.fechaCreacion) {
        <span class="cp-meta cp-fecha">
          <mat-icon>event</mat-icon>
          Actualizada el
          {{
            configDeseada?.fechaActualizacion || configDeseada?.fechaCreacion
              | date: 'dd/MM/yyyy HH:mm'
          }}
        </span>
      }
    </div>
  }

  <!-- Cargando -->
  @if (cargando()) {
    <div class="cp-cargando">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  }

  <!-- Vacío -->
  @if (!cargando() && ejecuciones().length === 0) {
    <div class="cp-vacio">
      <mat-icon>inbox</mat-icon>
      <p>No hay comandos de aplicación de perfil para este dispositivo.</p>
    </div>
  }

  <!-- Timeline (git-graph): tronco de ciclos + ramas por aspecto -->
  @if (!cargando() && ejecuciones().length > 0) {
    <div class="cp-graph">
      @for (eje of ejecucionesVisibles(); track eje.clave) {
        <div class="cp-ciclo" [class]="cicloClase(eje)">
          <span class="cp-ciclo-dot"></span>

          <!-- Header del ciclo: clic = colapsar/expandir (acordeón) -->
          <div
            class="cp-ciclo-head irx-clickeable"
            role="button"
            tabindex="0"
            [attr.aria-expanded]="estaExpandido(eje.clave)"
            (click)="toggleCiclo(eje.clave)"
            (keydown.enter)="toggleCiclo(eje.clave)"
            [class.colapsado]="!estaExpandido(eje.clave)"
          >
            <mat-icon class="cp-ciclo-chevron">
              {{ estaExpandido(eje.clave) ? 'expand_less' : 'expand_more' }}
            </mat-icon>
            <span class="cp-ciclo-origen">{{ origenLabel(eje.origen) }}</span>
            <span class="cp-ciclo-fecha">
              Inicio {{ eje.fechaInicio | date: 'dd/MM/yyyy HH:mm' }}
              @if (eje.fechaInicio !== eje.fecha) {
                · última {{ eje.fecha | date: 'dd/MM/yyyy HH:mm' }}
              }
            </span>
            @if (eje.objetivoNombre) {
              <span class="cp-ciclo-objetivo">
                · {{ nivelLabel(eje.objetivoNivel) }}: {{ eje.objetivoNombre }}
              </span>
            }
            <span class="cp-ciclo-resumen">
              <span class="cp-ciclo-cant">
                {{ pasosDelCiclo(eje) }} downlink(s)
              </span>
              @if (eje.ok) {
                <span class="r-ok">
                  <mat-icon inline>check_circle</mat-icon>
                  {{ eje.ok }}
                </span>
              }
              @if (eje.fallo) {
                <span class="r-fallo">
                  <mat-icon inline>cancel</mat-icon>
                  {{ eje.fallo }}
                </span>
              }
              @if (eje.pendiente) {
                <span class="r-pend">
                  <mat-icon inline>pending</mat-icon>
                  {{ eje.pendiente }}
                </span>
              }
            </span>
          </div>

          <!-- Ramas: cada una es un aspecto (SET → AutoGET → respuesta) -->
          @if (estaExpandido(eje.clave)) {
            <div class="cp-ramas">
              @for (rama of eje.ramas; track $index) {
                <div class="cp-rama">
                  @if (rama.aspecto) {
                    <div class="cp-rama-aspecto">
                      <mat-icon>tune</mat-icon>
                      {{ rama.aspecto }}
                    </div>
                  }

                  <div class="cp-cadena">
                    @for (paso of rama.pasos; track $index; let last = $last) {
                      <div class="cp-paso" [class]="procesoClase(paso)">
                        <!-- cabecera del nodo -->
                        <div class="cp-paso-top">
                          <span
                            class="cp-paso-icon"
                            [class]="estadoClase(paso.job.estado)"
                          >
                            <mat-icon>
                              {{ estadoIcono(paso.job.estado) }}
                            </mat-icon>
                          </span>
                          <span class="cp-paso-nombre">
                            {{ paso.job.nombre }}
                          </span>
                          <span class="cp-paso-puerto">
                            pto {{ paso.job.puerto }}
                          </span>
                          <span
                            class="cp-paso-tag"
                            [class]="procesoClase(paso)"
                          >
                            {{
                              paso.tipo === 'set'
                                ? 'SET'
                                : paso.tipo === 'autoget'
                                  ? 'AutoGET'
                                  : 'GET'
                            }}
                          </span>
                        </div>
                        @if (paso.aspecto) {
                          <div
                            class="cp-paso-aspecto"
                            matTooltip="Aspecto de la config al que corresponde este downlink"
                          >
                            <mat-icon>tune</mat-icon>
                            {{ paso.aspecto }}
                          </div>
                        }

                        <!-- doble carril: cola (transporte) + dispositivo (comando).
                           Cada riel muestra TODOS los estados recorridos. -->
                        <div class="cp-carriles">
                          <div
                            class="cp-carril"
                            matTooltip="Estados por los que pasó en la fila de envío (transporte)"
                          >
                            <span class="cp-carril-lbl">fila</span>
                            <!-- El contenido del riel va en un cuerpo propio: si
                                 los chips no entran envuelven acá adentro, sin
                                 arrastrar el label ni partir el stepper. -->
                            <div class="cp-carril-body">
                              <span class="cp-stepper">
                                @for (
                                  st of colaPasos(paso.job);
                                  track $index;
                                  let last = $last
                                ) {
                                  <span
                                    class="cp-step"
                                    [class]="st.clase"
                                    [class.actual]="st.actual"
                                    [class.inferido]="st.inferido"
                                    [matTooltip]="
                                      st.fecha
                                        ? (st.fecha
                                          | date: 'dd/MM/yyyy HH:mm:ss')
                                        : 'sin timestamp'
                                    "
                                  >
                                    {{ estadoLabel(st.estado) }}
                                  </span>
                                  @if (!last) {
                                    <mat-icon class="cp-step-flecha">
                                      chevron_right
                                    </mat-icon>
                                  }
                                }
                              </span>
                              @if (paso.job.intentos > 1) {
                                <span
                                  class="cp-mini"
                                  matTooltip="Intentos de transporte"
                                >
                                  <mat-icon>refresh</mat-icon>
                                  {{ paso.job.intentos }}
                                </span>
                              }
                              <!-- VEREDICTO del paso: por qué vía cerró. Antes
                                   vivía sólo en el plan de Redis (que se borra al
                                   terminar), así que la card no podía distinguir
                                   "confirmado por ACK sin verificar" de
                                   "verificado por el eco del equipo".
                                   El chip lleva la etiqueta corta; la larga va al
                                   tooltip, porque en una card de esta ancho la
                                   completa se partía en tres renglones. -->
                              @if (paso.job.veredictoPor) {
                                <span
                                  class="cp-st-chip"
                                  [class]="
                                    veredictoClase(paso.job.veredictoPor)
                                  "
                                  [matTooltip]="
                                    veredictoLabel(paso.job.veredictoPor) +
                                    (paso.job.fechaVeredicto
                                      ? ' · ' +
                                        (paso.job.fechaVeredicto
                                          | date: 'dd/MM/yyyy HH:mm:ss')
                                      : '')
                                  "
                                >
                                  <mat-icon>
                                    {{ veredictoIcono(paso.job.veredictoPor) }}
                                  </mat-icon>
                                  {{
                                    veredictoLabelCorto(paso.job.veredictoPor)
                                  }}
                                </span>
                              }
                              @if (paso.job.agotoReintentos) {
                                <span
                                  class="cp-mini"
                                  matTooltip="El paso consumió todos sus envíos sin obtener respuesta del dispositivo"
                                >
                                  <mat-icon>timer_off</mat-icon>
                                  envíos agotados
                                </span>
                              }
                            </div>
                          </div>

                          <div
                            class="cp-carril"
                            matTooltip="Estado real en el dispositivo (comando LoRaWAN)"
                          >
                            <span class="cp-carril-lbl">disp</span>
                            <div class="cp-carril-body">
                              @if (paso.comando?.estado) {
                                <span
                                  class="cp-st-chip"
                                  [class]="comandoClase(paso.comando?.estado)"
                                >
                                  <mat-icon>
                                    {{ comandoIcono(paso.comando?.estado) }}
                                  </mat-icon>
                                  {{ comandoLabel(paso.comando?.estado) }}
                                </span>
                                @if (paso.comando?.fCnt) {
                                  <span
                                    class="cp-mini"
                                    matTooltip="fCnt LoRaWAN"
                                  >
                                    fCnt {{ paso.comando?.fCnt }}
                                  </span>
                                }
                              } @else {
                                <span
                                  class="cp-st-chip e-na"
                                  matTooltip="Sin comando asociado todavía"
                                >
                                  Sin comando
                                </span>
                              }
                            </div>
                          </div>
                        </div>

                        @if (paso.comando?.respuesta) {
                          <div
                            class="cp-paso-resp"
                            matTooltip="Respuesta del uplink"
                          >
                            <span class="cp-carril-lbl">resp</span>
                            <code>{{ paso.comando?.respuesta }}</code>
                          </div>
                        }

                        @if (paso.job.payload) {
                          <div class="cp-paso-meta">
                            <span>
                              {{
                                paso.job.fechaConfirmado ||
                                  paso.job.fechaEnviado ||
                                  paso.job.fechaCreacion
                                  | date: 'dd/MM/yyyy HH:mm:ss'
                              }}
                            </span>
                            <span
                              class="cp-payload"
                              matTooltip="Payload enviado (hex)"
                            >
                              ·
                              <code>{{ paso.job.payload }}</code>
                            </span>
                            <!-- El gateway vive acá, con el resto de los datos
                                 del envío, y no suelto entre los estados del
                                 riel de cola. -->
                            @if (paso.job.gatewayEui) {
                              <span
                                class="cp-payload"
                                matTooltip="Gateway al que el plan le ocupó cupo (congelado al armarlo)"
                              >
                                ·
                                <mat-icon>podcasts</mat-icon>
                                <code>{{ paso.job.gatewayEui }}</code>
                              </span>
                            }
                          </div>
                        }

                        <!-- Discrepancias de la última comparación (solo ciclo
                           reciente): qué tenía el dispositivo vs lo deseado.
                           Bajo demanda (botón) para no ocupar espacio. -->
                        @if (paso.diffs?.length) {
                          <button
                            irxBoton="texto"
                            tamano="compacto"
                            class="cp-diffs-btn"
                            [attr.aria-expanded]="diffsAbierto(paso.job._id)"
                            (click)="toggleDiffs(paso.job._id)"
                          >
                            <mat-icon>difference</mat-icon>
                            {{ diffsAbierto(paso.job._id) ? 'Ocultar' : 'Ver' }}
                            valores que se modificarán ({{
                              paso.diffs?.length
                            }})
                            <mat-icon class="cp-diffs-btn-chev">
                              {{
                                diffsAbierto(paso.job._id)
                                  ? 'expand_less'
                                  : 'expand_more'
                              }}
                            </mat-icon>
                          </button>
                          @if (diffsAbierto(paso.job._id)) {
                            <div class="cp-diffs">
                              @for (d of paso.diffs; track $index) {
                                <div class="cp-diff">
                                  <span class="cp-diff-campo">
                                    {{ d.campo }}
                                  </span>
                                  <span
                                    class="cp-diff-val real"
                                    matTooltip="Valor real en el dispositivo"
                                  >
                                    real: {{ valorDiff(d.real) }}
                                  </span>
                                  <mat-icon class="cp-diff-arr">arrow_forward</mat-icon>
                                  <span
                                    class="cp-diff-val esp"
                                    matTooltip="Valor deseado (perfil)"
                                  >
                                    deseado: {{ valorDiff(d.esperado) }}
                                  </span>
                                </div>
                              }
                            </div>
                          }
                        }

                        @if (paso.job.ultimoError) {
                          <div class="cp-paso-error">
                            <mat-icon>error</mat-icon>
                            {{ paso.job.ultimoError }}
                          </div>
                        }

                        <!-- reintentos de transporte (BullMQ, mismo job) -->
                        @if (paso.job.intentosLog?.length) {
                          <div class="cp-intentos-log">
                            @for (it of paso.job.intentosLog; track $index) {
                              <div class="cp-intento">
                                <span
                                  class="cp-intento-icon"
                                  [class]="intentoClase(it.resultado)"
                                >
                                  <mat-icon>
                                    {{ intentoIcono(it.resultado) }}
                                  </mat-icon>
                                </span>
                                <span class="cp-intento-num">
                                  #{{ it.numero }}
                                </span>
                                <span class="cp-intento-fecha">
                                  {{ it.fecha | date: 'dd/MM/yyyy HH:mm:ss' }}
                                </span>
                                <span class="cp-intento-res">
                                  {{ it.resultado }}
                                </span>
                                <!-- Espera en NUESTRA fila de envío +
                                     despacho. Un envío que esperó más que el
                                     timeout de ACK no podía ser confirmado en
                                     plazo: el paso ya había vencido cuando el
                                     downlink salió. -->
                                @if (it.esperaColaSeg != null) {
                                  <span
                                    class="cp-mini"
                                    [class.cp-mini-alerta]="esperaExcedida(it)"
                                    [matTooltip]="tooltipEspera(it)"
                                  >
                                    <mat-icon>timer</mat-icon>
                                    {{ fmtSeg(it.esperaColaSeg) }} en fila
                                    @if (it.despachoSeg != null) {
                                      · {{ fmtSeg(it.despachoSeg) }} despacho
                                    }
                                  </span>
                                }
                                <!-- HUÉRFANO: salió después del veredicto del
                                     paso, así que nadie lo va a confirmar. -->
                                @if (esHuerfano(paso.job, it)) {
                                  <span
                                    class="cp-mini cp-mini-alerta"
                                    matTooltip="Este downlink se emitió después de que el paso ya tenía veredicto: lo cerró el envío anterior mientras éste esperaba en la fila. Nadie lo va a confirmar."
                                  >
                                    <mat-icon>warning</mat-icon>
                                    huérfano
                                  </span>
                                }
                                @if (it.error) {
                                  <span class="cp-intento-error">
                                    · {{ it.error }}
                                  </span>
                                }
                              </div>
                            }
                          </div>
                        }
                      </div>

                      <!-- flecha de encadenamiento SET → AutoGET -->
                      @if (!last) {
                        <div class="cp-cadena-flecha">
                          <mat-icon>arrow_forward</mat-icon>
                        </div>
                      }
                    }

                    <!-- resultado de la rama: lo dictan los SET (los downlinks
                         que escriben config), no el último paso. El AutoGET
                         puede quedar Ejecutado (llegó el eco) y el SET quedar
                         "No Ejecutado" por payload discrepante → NO aplicado.
                         Aplicado puede ser por eco del GET de cierre (confirmado
                         por uplink) o solo por ACK del SET (feature
                         aplicar-por-ACK): en ese caso se muestra "sin confirmar"
                         porque no hubo verificación por uplink. Si no está
                         resuelta ni rechazada NO se muestra nada (puede estar
                         aplicada igual, ej. comando Recibido). -->
                    @if (ramaResuelta(rama)) {
                      <div class="cp-cadena-flecha">
                        <mat-icon>arrow_forward</mat-icon>
                      </div>
                      @if (ramaSoloConsulta(rama)) {
                        <div
                          class="cp-rama-resp ok"
                          matTooltip="El dispositivo respondió la consulta por uplink"
                        >
                          <mat-icon>check_circle</mat-icon>
                          Consulta respondida
                        </div>
                      } @else if (ramaAplicadaPorAck(rama)) {
                        <div
                          class="cp-rama-resp ok-ack"
                          matTooltip="Aplicado por ACK del dispositivo, sin confirmación por uplink"
                        >
                          <mat-icon>check_circle</mat-icon>
                          Aplicado por ACK
                        </div>
                      } @else {
                        <div class="cp-rama-resp ok">
                          <mat-icon>check_circle</mat-icon>
                          Aplicado por uplink
                        </div>
                      }
                    } @else if (ramaNoAplicada(rama)) {
                      <div class="cp-cadena-flecha">
                        <mat-icon>arrow_forward</mat-icon>
                      </div>
                      <div
                        class="cp-rama-resp fallo"
                        [matTooltip]="ramaMotivoNoAplicada(rama)"
                      >
                        <mat-icon>cancel</mat-icon>
                        No aplicado
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>

    <!-- Paginación del tronco: la línea de tiempo es potencialmente infinita,
         se carga de a tandas para no ocupar espacio sin fin. -->
    @if (restantes() > 0 || hayExpandidos()) {
      <div class="cp-paginacion">
        @if (restantes() > 0) {
          <button irxBoton="secundario" (click)="mostrarMas()">
            <mat-icon>expand_more</mat-icon>
            Mostrar más ({{ restantes() }} restantes)
          </button>
          <button irxBoton="texto" (click)="mostrarTodos()">
            Mostrar todos
          </button>
        }
        @if (hayExpandidos()) {
          <button irxBoton="texto" (click)="mostrarMenos()">
            <mat-icon>expand_less</mat-icon>
            Mostrar menos
          </button>
        }
      </div>
    }
  }
</app-dt-card>
